import { render, staticRenderFns } from "./GetMoreZone.vue?vue&type=template&id=3a6b9bc2&scoped=true&"
import script from "./GetMoreZone.vue?vue&type=script&lang=js&"
export * from "./GetMoreZone.vue?vue&type=script&lang=js&"
import style0 from "./GetMoreZone.vue?vue&type=style&index=0&id=3a6b9bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b9bc2",
  null
  
)

export default component.exports